import HeaderSubPage from "./partial/HeaderSubPage";
import React from "react";

export default function NotFound() {
    const path = window.location.pathname

    if (path.includes("SchwaBo")) {
        window.location.href = "https://abo-bonus.globalis.de";
        return;
    }

    if (path.includes("Augsburger")) {
        window.location.href = "https://augsburg.globalis.de";
        return;
    }

    if (path.includes("AVG")) {
        window.location.href = "https://avg.globalis.de";
        return;
    }

    if (path.includes("AZ")) {
        window.location.href = "https://az.globalis.de";
        return;
    }

    if (path.includes("EsslingerZeitung")) {
        window.location.href = "https://ez-leserreisen.globalis.de";
        return;
    }

    if (path.includes("FAZ")) {
        window.location.href = "https://faz.globalis.de";
        return;
    }

    if (path.includes("fnp")) {
        window.location.href = "https://fnp.globalis.de";
        return;
    }

    if (path.includes("giesseneranzeiger")) {
        window.location.href = "https://ga.globalis.de";
        return;
    }

    if (path.includes("gaz")) {
        window.location.href = "https://gaz.globalis.de";
        return;
    }

    if (path.includes("Heilbronner_Stimme")) {
        window.location.href = "https://hn.globalis.de";
        return;
    }

    if (path.includes("hanau")) {
        window.location.href = "https://hu.globalis.de";
        return;
    }

    if (path.includes("kreisanzeiger")) {
        window.location.href = "https://kreisanzeiger.globalis.de";
        return;
    }

    if (path.includes("krzbb")) {
        window.location.href = "https://krzbb.globalis.de";
        return;
    }

    if (path.includes("Offenbach")) {
        window.location.href = "https://op.globalis.de";
        return;
    }

    if (path.includes("Rundschau")) {
        window.location.href = "https://rundschau.globalis.de";
        return;
    }

    if (path.includes("suedkurier")) {
        window.location.href = "https://sk-reisen.globalis.de";
        return;
    }

    if (path.includes("Stuttgarter_Zeitung")) {
        window.location.href = "https://stz.globalis.de";
        return;
    }

    if (path.includes("leserreisen")) {
        window.location.href = "https://sz.globalis.de";
        return;
    }

    if (path.includes("Tagesspiegel")) {
        window.location.href = "https://ts.globalis.de";
        return;
    }

    if (path.includes("usinger")) {
        window.location.href = "https://usingen.globalis.de";
        return;
    }

    if (path.includes("GN_Reisekalender")) {
        window.location.href = "/reisekalender";

    } else if (path.includes("GN_ALLE")) {
        window.location.href = "/reisefinder";

    } else if (path.includes("GN_Flug")) {
        window.location.href = "/reisefinder";

    } else if (path.includes(".php")) {
        window.location.href = "/";
    }

    return (
        <div>
            <div className="site wrapper-content">
                <HeaderSubPage title={'404'}></HeaderSubPage>
                <section className="content-area">
                    <div className="container">
                        <div className="row">

                            <div className="page-wrap d-flex flex-row align-items-center">
                                <div className="container">
                                    <div className="row justify-content-center">
                                        <div className="col-md-12 text-center">
                                            <h1 className="display-1 d-block">404</h1>
                                            <h1 className="mb-4">Sorry. Die angeforderte Seite / URL existiert
                                                nicht.</h1>
                                            <a href={`${process.env.PUBLIC_URL}/`} className="btn btn-primary"
                                               title="Hauptseite">zu
                                                Hauptseite</a>

                                            <a href={`${process.env.PUBLIC_URL}/reisefinder`}
                                               className="btn btn-primary mx-2" title="Alle
                                                Reisen im Überblick">Alle
                                                Reisen im Überblick</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    )
}